/**
 * List of travel platform specific domain names
 * Be sure to update the SERVER level list, if modifying this list
 *
 * Differences here vs server are, the following:
 * - don't need accessdevelopment.com in either list
 * - don't need adcrws.com in stage list
 * - don't include the `*.` in any domain
 */
export const travelHostsProd = [
  "accessperks.com",
  "enjoymydeals.com",
  "adcrws.com",
  "sleepdiscounts.com",
  "zealtrips.com",
  "vacationsidekickwbw.com",
  "vacationsidekickcw.com",
];

export const travelHostsStage = ["accessperks.com"];
